import { FormEvent } from "react"
import { Head, Link, useForm, usePage } from "@inertiajs/react"
import { Check } from "lucide-react"
import { AuthShell } from "@/components/AuthShell"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

import type { PageProps } from "@/types/inertia"

export default function PasswordNew() {
  const { props } = usePage<PageProps>()
  const form = useForm({ email: "" })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post("/passwords")
  }

  return (
    <>
      <Head title="Reset your password">
        <meta name="description" content="Request a password reset link by email." />
        <meta property="og:title" content="Reset your password" />
        <meta property="og:description" content="Request a password reset link by email." />
      </Head>
      <AuthShell>
        <h2 className="auth-title">Reset your password</h2>
        <p className="mt-1.5 text-sm text-ink-muted">
          Enter your work email and we&apos;ll send a reset link.
        </p>

        {props.flash?.notice && (
          <div className="mt-4 flex items-start gap-2 rounded-lg border border-hairline bg-surface p-3">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-accent-display" />
            <p className="text-xs leading-relaxed text-ink-muted">
              {props.flash.notice}
            </p>
          </div>
        )}

        <form onSubmit={submit} className="mt-4 space-y-4">
          <div className="space-y-1.5">
            <label htmlFor="email">Email</label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              autoFocus
              required
              placeholder="you@company.com"
              value={form.data.email}
              onChange={(e) => form.setData("email", e.target.value)}
            />
          </div>
          <Button type="submit" className="w-full" disabled={form.processing}>
            Send reset link
          </Button>
          <p className="text-center">
            <Link href="/login" className="text-sm">
              Back to log in
            </Link>
          </p>
        </form>
      </AuthShell>
    </>
  )
}
